import styled from 'styled-components'

const Container = styled.div`
  /* margin-left: 80px; */
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.body};
  margin-top: 20px;
  .targetTitle {
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-left: 0px;
  }
`
const LinkWrapper = styled.div`
  display: flex;
  height: 120px;
  width: 100%;
  margin-bottom: 30px;

  .swiper-container {
    margin-left: -12px;
  }
  .owl-theme {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: auto;
    margin-left: -10px;
  }

  .link {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-top: 20px;
  }
  .link-box {
    margin-right: 50px;
    width: 200px;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .emergency {
    color: ${({ theme }) => theme.colors.Emergency};
  }
  .link-name {
    font-size: 18px;
    line-height: 22px;
    padding-left: 10px;
  }
`

const CardBtnWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  margin-left: 10px;
  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    width: 100%;
    margin-left: 0px;
  }

  /* new emergency card style */
  .card_one {
    background-color: ${({ theme }) => theme.colors.emergencyColor};
    color: ${({ theme }) => theme.colors.white};
    height: 120px;
    width: 90%;
    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xxl};
      letter-spacing: 1px;
      margin: 0;
    }

    .title {
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x2};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
  }
  .card_two {
    background-color: ${({ theme }) => theme.colors.emergencyColorTwo};
    width: 60%;
    height: 125px;
    color: ${({ theme }) => theme.colors.navyBlue};
    .flex_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: column-reverse;
    }

    .balance {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x2};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x5};
      }
    }

    .title {
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x4};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      line-height: 26px;
      letter-spacing: 0.75px;
      margin: 0;
    }

    .icon_wrapper {
      align-self: flex-end;
      margin-top: 1rem;
    }

    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }

  .general-owl-theme {
  }
  .owl-dots {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      display: none;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
    }
  }

  .owl-carousel button.owl-dot {
    background: #6e7191;
    color: white;
    border: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .owl-carousel button.owl-dot.active {
    background: ${({ theme }) => theme.colors.Emergency};
    border-radius: 10px;
    margin: 0 5px;
    width: 22px;
    height: 6px;
  }

  @media (min-width: ${({ theme }) => theme.responsive.laptop}) {
    .rec-pagination {
      display: block;
    }

    .rec-carousel-item {
      margin-right: 4px;
    }
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    /* .rec .rec-dot_active {
      width: 22px;
      height: 5px;
      background: ${({ theme }) => theme.colors.primary};
      border-radius: 10px;
      margin-top: 8px;
    } */
  }
  @media (min-width: ${({ theme }) => theme.responsive.ipad}) {
    .rec-item-wrapper {
    }
    .rec-carousel-item {
      margin-right: 4px;
    }
  }
  @media (min-width: ${({ theme }) => theme.responsive.laptop}) {
    .rec-item-wrapper {
    }
    .rec-carousel-item {
      margin-right: 4px;
    }
  }

  .card-img {
    display: none;
  }
  .owl-carousel .owl-item img {
    display: block;
    width: auto;
  }

  .btn-container {
    display: flex;
    width: 320px;
    justify-content: space-between;
    margin-top: 3rem;
    margin-left: -5px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      /* padding-right: 2px; */
      margin: 3rem 0;
      display: none;
    }

    .btn-icon {
      padding-right: 7px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        padding-right: 2px;
        margin-bottom: 3rem;
      }
    }

    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 80%;
      justify-content: start;
    }
  }

  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
  }
`

const TargetDataWrapper = styled.div`
  width: auto;
  margin-top: -50px;
  .target {
    /* margin-top: 4rem; */
    color: ${({ theme }) => theme.colors.dark};

    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      display: none;
    }
  }

  .target-btn-container {
    /* margin-left: 30px;
  margin-top: 30px; */

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: auto;
      display: flex;
      margin-left: 0px;

      /* justify-content: center;
  align-items: center; */
    }
  }
`
const SavingsFlexWrapper = styled.div`
  display: flex;
  /* justify-content: space-between; */
  width: 100%;
  @media (max-width: 1000px) {
    display: block;
  }
`

const FlexContainerOne = styled.div`
  width: 67%;
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
  }
`
const FlexContainerTwo = styled.div`
  width: 33%;
  @media (max-width: 1000px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /* background-color: red; */
`

export {
  Container,
  LinkWrapper,
  CardBtnWrapper,
  TargetDataWrapper,
  FlexContainerOne,
  SavingsFlexWrapper,
  FlexContainerTwo,
}
